/// <reference path="../wpt.ts" />
/*
    Basic viewer template to be launched from search hit lists
    Assumes the inherited widget contains a list of documents.
    - Items with no built-in list UI which create a hit-list for external display
      should repurpose (rename?) and execute the custom query detail view.
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutFlexView extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
            }
        }
        Navigation.DetailLayoutFlexView = DetailLayoutFlexView;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
